import { useState, useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/AuthContext'
import LoadingPage from '@/components/LoadingPage'
import { getAllProductRegistrations } from '@/api/services/securityServices'

export const ProtectedRoute = () => {
  const { isAuthenticated, loading: authLoading } = useAuth()
  const [isRegistered, setIsRegistered] = useState(null)
  const [checkingRegistration, setCheckingRegistration] = useState(true)
  const location = useLocation()

  useEffect(() => {
    const checkRegistration = async () => {
      try {
        const response = await getAllProductRegistrations()
        // A product is registered if at least one registration has a license key
        const registrations = Array.isArray(response) ? response : [response]
        const registered = registrations.some(
          reg => reg && reg.licenseKey && reg.licenseKey.trim() !== ''
        )
        console.log('[LicenseCheck] Status:', registered, 'Path:', location.pathname)
        setIsRegistered(registered)
      } catch (error) {
        console.error('License check failed:', error)
        // If API fails (e.g., 404), treat as unregistered to be safe, or as registered if backend is missing
        setIsRegistered(true)
      } finally {
        setCheckingRegistration(false)
      }
    }

    if (isAuthenticated) {
      checkRegistration()
    } else {
      setCheckingRegistration(false)
    }
  }, [isAuthenticated, location.pathname]) // Re-check on path change if needed, or just let the render handle it

  if (authLoading || checkingRegistration) {
    return <LoadingPage />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  const isLicensePath = location.pathname === '/systemMaintenanceModules/licenseManagement'

  // CRITICAL: If not registered, force redirect to license page
  if (isRegistered === false && !isLicensePath) {
    console.log('[LicenseCheck] FORCING REDIRECT to License Management')
    return <Navigate to="/systemMaintenanceModules/licenseManagement" replace />
  }

  return <Outlet />
}

export const PublicRoute = () => {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return <LoadingPage />
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }
  return <Outlet />
}
